<template>
<div class="products-table">
  <table
    class="table table-condensed table-bordered table-striped"
    :class="{ 'table-centered': isCentered, 'table-left': !isCentered }"
  >
    <thead>
    <tr v-if="title">
      <th class="products-table-title" :colspan="headersArr.length" v-text="title"></th>
    </tr>
    <tr>
      <th v-for="value in headersArr" v-text="value"></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in rowsArr">
      <td v-for="values in row">
        <span v-if="values.length === 1 && values[0].test" v-html="testValue(values[0])"></span>
        <template v-else-if="values.length === 1 && values[0].type === 'score'">
          <CoreScore
            :score="values[0].text"
            :text="values[0].score_text"
            :color="values[0].score_color"
          />
        </template>
        <FactsSectionValues v-else :values="values" separator=" / " />
      </td>
    </tr>
    </tbody>
  </table>
  <p v-if="text" class="products-table-text" v-text="text"></p>
</div>
</template>

<script setup>
import FactsSectionValues from "~/components/shared/product/FactsSectionValues";
import labTest from "~/utils/labTest";
import CoreScore from "~/components/shared/product/CoreScore";

const { t } = useI18n();

const props = defineProps({
  headers: {
    type: String,
    required: true,
  },
  rows: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  centered: {
    type: String,
    default: '',
  },
})

const headersArr = computed(() => JSON.parse(props.headers))
const rowsArr = computed(() => JSON.parse(props.rows))
const isCentered = computed(() => props.centered === 'yes');

function testValue(value) {
  const testValue = labTest.getTestValue(value.test, value.text);

  if (typeof testValue === 'boolean') {
    return testValue ? t('generic.yes') : t('generic.no');
  }

  return testValue;
}
</script>

<style lang="scss" scoped>
.products-table {
  margin-top: 8px;
  overflow-x: auto;

  .table {
    margin-bottom: 10px;
  }
  table.table-centered {
    th, td {
      text-align: center;
    }
  }

  table.table-left {
    th, td {
      text-align: left;
    }
  }
}
.products-table-title {
  font-weight: bold;
}
.products-table-text {
  font-style: italic;
  text-align: right;
}
</style>